module.exports = __webpack_public_path__ + "img/img-draditional-market.380517cc.png";